import React, { useState } from "react";
import { Link } from "react-router-dom";

const NavbarTwo = () => {
  const [isHidden, SetIsHidden] = useState(false);
  let logo = process.env.PUBLIC_URL + "assets/media/logo-4.png";

  return (
    <div
      className="app-header header--transparent sticker stick slideDown"
      id="main-menu"
      style={{ opacity: 1 }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-4 col-sm-5 col-5">
            <div className="logo">
              <a href="/">
                <img
                  className="logo-1"
                  src={logo}
                  alt="app landing"
                  width={50}
                />
              </a>
            </div>
          </div>
          <div className="col-lg-8 d-none d-lg-block">
            <div className="mainmenu-wrapper">
              <nav>
                <ul className="main-menu">
                  <li className="">
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="/privacy">Privacy</a>
                  </li>
                  <li>
                    <a href="/tnc">Terms&Conditions</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div className="col-sm-7 col-7 d-block d-lg-none">
            <div className="mobile-menu mean-container">
              <div className="mean-bar">
                {!isHidden ? (
                  <a
                    className="meanmenu-reveal"
                    onClick={() => SetIsHidden(true)}
                  >
                    <span></span>
                    <span></span>
                    <span></span>
                  </a>
                ) : (
                  <div className="text-end">
                    <button
                      className="btn btn-outline-primary fs-2 fw-bolder"
                      style={{
                        boxShadow: "none",
                        outline: "none",
                        border: "none",
                        background: "none",
                        color: "#fff",
                      }}
                      onClick={() => SetIsHidden(!isHidden)}
                    >
                      X
                    </button>
                  </div>
                )}
                <nav className="mean-nav">
                  {isHidden ? (
                    <ul style={{ display: "" }}>
                      <li className="active">
                        <a href="/" onClick={() => SetIsHidden(!isHidden)}>
                          Home
                        </a>
                      </li>
                      <li>
                        <Link
                          to="/privacy"
                          onClick={() => SetIsHidden(!isHidden)}
                        >
                          Privacy
                        </Link>
                      </li>
                      <li>
                        <Link to="/tnc" onClick={() => SetIsHidden(!isHidden)}>
                          Terms&Conditions
                        </Link>
                      </li>
                    </ul>
                  ) : null}
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavbarTwo;
